// reducers/tasksReducer.ts
import { SET_TASKS } from '../actions';
import Action from '../actions';
import { Task } from '../type';

const initialState = null;

const tasksReducer = (state = initialState, action: Action): Task[] => {
  switch (action.type) {
    case SET_TASKS:
      return action.payload;
    default:
      return state;
  }
};

export default tasksReducer;
